import { SectionsKey } from '~/constants/enum';

const PageStruct = {
    id: 'affiliate',
    useLayout: true,
    children: [{ id: SectionsKey.Affiliate, order: 1 }]
};

export default PageStruct;
